import React, {useId} from 'react';

import {MenuItem} from '@pb/kit-component-menu';
import {hashedClasses, withCssModule} from '@pb/kit-util-with-css-module';

import styles from './listbox.component.module.styl';

import type {ComponentPropsWithoutRef, ReactNode} from 'react';


const classes = hashedClasses(styles);
const classNames = withCssModule(styles);

type NativeProps = ComponentPropsWithoutRef<'ul'>;

export interface ListboxGroupProps extends NativeProps {
    /**
     * This caption will be displayed for item
     */
    caption: ReactNode,
}

/**
 * ListboxGroup
 *
 * This component is used to group items in Listbox
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/utils-listbox--documentation}
 * */
export function ListboxGroup(props: ListboxGroupProps) {
    const {caption, children, ...nativeProps} = props;
    const id = useId();

    return (
        <ul
            role="group"
            aria-labelledby={id}
            {...nativeProps}
            className={classNames('list-box-group', nativeProps.className)}>
            <MenuItem
                separated={true}
                role="none"
                id={id}
                className={classes['list-box-group-caption']}
                caption={caption}
            />
            <div>
                {children}
            </div>
        </ul>
    );
}
